<app-rich-text-editor
  [formControl]="introductionControl"
  placeholder="Please add introduction text here."
  [required]="true"></app-rich-text-editor>
<ng-content></ng-content>
